import { render, staticRenderFns } from "./CompanyMaterialsConfig.vue?vue&type=template&id=2a5671b8&scoped=true&"
import script from "./CompanyMaterialsConfig.vue?vue&type=script&lang=js&"
export * from "./CompanyMaterialsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5671b8",
  null
  
)

export default component.exports